import commonDeDe from "./de-DE/common.json.js";
import glossaryDeDe from "./de-DE/glossary.json.js";
import translationDeDe from "./de-DE/translation.json.js";
import commonEnUs from "./en-US/common.json.js";
import glossaryEnUs from "./en-US/glossary.json.js";
import translationEnUs from "./en-US/translation.json.js";
import commonEsEs from "./es-ES/common.json.js";
import glossaryEsEs from "./es-ES/glossary.json.js";
import translationEsEs from "./es-ES/translation.json.js";
import commonPtBr from "./pt-BR/common.json.js";
import glossaryPtBr from "./pt-BR/glossary.json.js";
import translationPtBr from "./pt-BR/translation.json.js";
const resources = {
  "de-DE": {
    common: commonDeDe,
    glossary: glossaryDeDe,
    translation: translationDeDe
  },
  "en-US": {
    common: commonEnUs,
    glossary: glossaryEnUs,
    translation: translationEnUs
  },
  "es-ES": {
    common: commonEsEs,
    glossary: glossaryEsEs,
    translation: translationEsEs
  },
  "pt-BR": {
    common: commonPtBr,
    glossary: glossaryPtBr,
    translation: translationPtBr
  }
};
export {
  resources as default
};
